<div class="text">
  <ng-container [formGroup]="model">
    <div #editor class="editor">
      @if (model.value.source === 'Text') {
        <lib-i18n-text-input (blurred)="hideOnBlur()" formControlName="text"
          >{{ 'clgm4onbl000008mdezm8807s' | translate | async }}
        </lib-i18n-text-input>
      }
      @if (model.value.source === 'Image') {
        <mat-form-field libZalamoField [noBottomMargin]="true">
          <mat-label translate>clgmax2wl000008mi2iz32uv9</mat-label>
          <mat-select formControlName="fileName">
            @for (watermark of availableWatermarks$ | async; track watermark) {
              <mat-option [value]="watermark.fileName">{{
                watermark.name
              }}</mat-option>
            }
          </mat-select>
          <lib-zalamo-field-decoration></lib-zalamo-field-decoration
        ></mat-form-field>
      }
    </div>
  </ng-container>
  <lib-button
    (click)="openAdvanced()"
    data-vg="WatermarkInlineEditorAdvancedButton"
  >
    <mat-icon *libIsHandset="desktopAdvanced">settings</mat-icon>
    <ng-template #desktopAdvanced>
      <span forceContext="publicSessionEditor" translate
        >clgmaxz7h000108mihutsh88u</span
      >
    </ng-template>
  </lib-button>
</div>
